import React from 'react';
import { Pressable } from 'react-native';
import { Grid, Input, Text, useData, useForwardRef, wrapComponent } from 'unitx-ui';
export const mockTripleInputProps = {
  placeholder: 'Enter Value',
  value: 'Heyy',
  onValueChange: value => console.log('val:', value),
  getSuggestions: async () => [{
    title: 'Izmir',
    value: 'Izmir'
  }, {
    title: 'Istanbul',
    value: 'Istanbul'
  }]
};
const LINE_HEIGHT = 27;
export const TEXT_STYLE_MAP = {
  value: {// fontStyle: 'italic',
  },
  type: {// fontStyle: 'italic',
  },
  new: {
    fontStyle: 'italic'
  }
};

const TripleInputElement = (props, ref) => {
  const {
    value,
    textStyle,
    onEnter
  } = props;
  const [state, update] = useData({
    editable: props.editable,
    suggestions: [],
    isLoading: false,
    selectedSuggestion: null
  });
  const {
    style,
    placeholder,
    disabled,
    onValueChange,
    getSuggestions
  } = props;
  const inputRef = useForwardRef(ref, {}, () => ({
    changeMode: editable => {
      update(draft => {
        draft.editable = editable;
      });
      setTimeout(() => inputRef.current.focus(), 10);
    },
    getSelectedSuggestion: () => state.selectedSuggestion
  }));
  const onChangeText = React.useCallback(async value => {
    var _await$getSuggestions;

    const suggestions = (_await$getSuggestions = await (getSuggestions === null || getSuggestions === void 0 ? void 0 : getSuggestions({
      value
    }))) !== null && _await$getSuggestions !== void 0 ? _await$getSuggestions : [];
    update(draft => {
      draft.suggestions = suggestions;
      draft.isLoading = false;
      draft.selectedSuggestion = null;
    });
    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(value);
  }, [update, getSuggestions]);
  const onBlur = React.useCallback(() => {
    setTimeout(() => {
      update(draft => {
        draft.editable = false;
      });
    }, 200);
  }, [update]);
  return /*#__PURE__*/React.createElement(Pressable, {
    style: [{
      flex: 1
    }, style] // @ts-ignore
    ,
    onFocus: () => {
      !disabled && inputRef.current.changeMode(true);
    }
  }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Input, {
    ref: inputRef,
    value: value,
    onSubmitEditing: onEnter,
    style: [{
      width: '100%',
      lineHeight: LINE_HEIGHT,
      height: LINE_HEIGHT
    }, textStyle, state.editable ? null : {
      display: 'none'
    }],
    onChangeText: onChangeText,
    onBlur: onBlur,
    placeholder: placeholder
  }), /*#__PURE__*/React.createElement(Text, {
    style: [{
      width: '100%',
      lineHeight: LINE_HEIGHT,
      height: LINE_HEIGHT
    }, textStyle, state.editable ? {
      display: 'none'
    } : {}] // on
    ,
    ellipsizeMode: "tail",
    numberOfLines: 1
  }, value === '' ? placeholder : value)));
};

export const TripleInput = wrapComponent(TripleInputElement, {
  isForwardRef: true
});